import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OrderModel } from '../models/order';
import { NOTIFICATION_ORDER_ID } from '../constants/message';

interface NotificationInterface {
  data: OrderModel;
  newOrderId: string[];
  count: number;
  ringing: boolean;
  sound: boolean;
}

const initialState: NotificationInterface = {
  data: null!,
  newOrderId: localStorage.getItem(NOTIFICATION_ORDER_ID)
    ? JSON.parse(localStorage.getItem(NOTIFICATION_ORDER_ID) || '[]')
    : [],
  count: 0,
  ringing: false,
  sound: false,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    increaseNotification: (state: NotificationInterface, action: PayloadAction<OrderModel>) => {
      state.data = action?.payload;
      const newOrderIdValue: string[] = [...state?.newOrderId, action?.payload?.id];
      localStorage.setItem(NOTIFICATION_ORDER_ID, JSON.stringify(newOrderIdValue));
      state.newOrderId = newOrderIdValue;
      state.count = state.count + 1;
      state.ringing = true;
    },
    resetNotification: (state: NotificationInterface) => {
      state.data = null!;
      localStorage.removeItem(NOTIFICATION_ORDER_ID);
      state.count = 0;
    },
    removeNewOrderId: (state: NotificationInterface, action: PayloadAction<string>) => {
      const newOrderIdValue: string[] = state.newOrderId.filter((item) => item !== action.payload);
      state.newOrderId = newOrderIdValue;
      localStorage.setItem(NOTIFICATION_ORDER_ID, JSON.stringify(newOrderIdValue));
      if (state.count > 0) {
        state.count = state.count - 1;
      }
    },
    openSound: (state: NotificationInterface) => {
      state.ringing = true;
    },
    closeSound: (state: NotificationInterface) => {
      state.ringing = false;
    },
    openNotificationSound: (state: NotificationInterface) => {
      state.sound = true;
    },
    closeNotificationSound: (state: NotificationInterface) => {
      state.sound = false;
    },
  },
});

export const {
  increaseNotification,
  resetNotification,
  removeNewOrderId,
  openSound,
  closeSound,
  openNotificationSound,
  closeNotificationSound,
} = notificationSlice.actions;
export default notificationSlice.reducer;
